(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambienta-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Liquid's block.type always reports the schema placeholder "@app" for app
  // blocks (Shopify does not expose the underlying app/block identifier to
  // theme code), so the two widgets can only be told apart by the real
  // classes Judge.me renders. This runs before any layout-relevant CSS reads
  // data-widget-role, so reordering blocks in the editor can't silently swap
  // the gallery and reviews columns.
  function assignWidgetRoles(root) {
    var widgets = root.querySelectorAll('.ambienta-social-proof__widget[data-widget-role="pending"]');
    var missing = { gallery: true, reviews: true };
    widgets.forEach(function (widget) {
      var role = 'other';
      var galleryWidget = widget.querySelector('.jdgm-reviews-grid-widget');
      if (galleryWidget) {
        role = 'gallery';
        missing.gallery = false;
        setupGalleryModal(galleryWidget, root);
      } else if (widget.querySelector('.jdgm-testimonials-carousel')) {
        role = 'reviews';
        missing.reviews = false;
      }
      widget.setAttribute('data-widget-role', role);
    });

    if (window.Shopify && Shopify.designMode && widgets.length) {
      if (missing.gallery) warn(root, 'Falta el bloque "Reviews Grid" de Judge.me (galería de clientes).');
      if (missing.reviews) warn(root, 'Falta el bloque "Testimonials Carousel" de Judge.me (reseñas destacadas).');
    }
  }

  // Turns the real Judge.me gallery widget into a fullscreen browsing modal
  // on demand, without ever tearing a descendant out of its own .jdgm-widget
  // root (that's what broke the star icons earlier in this file) and without
  // touching a single one of its own elements/data.
  //
  // Root cause of the earlier click-through bug: the modal's wrapper lived
  // inside .ambienta-social-proof__inner, which has `position: relative;
  // z-index: 1` (added so real content sits above the decorative background
  // layer). That combination establishes a *stacking context* — and
  // `position: fixed` only escapes normal layout flow, not the stacking
  // context of an ancestor that creates one. So the "fullscreen" modal was
  // actually trapped inside stacking layer 1, and any page element with a
  // higher effective z-index (the sticky header, in this case) rendered and
  // received clicks above it. Confirmed live: with the modal open,
  // document.elementFromPoint() over the header returned the header itself,
  // not the modal.
  //
  // Fix: a true DOM portal. Two separate containers exist —
  //   1. a *teaser* that never moves, sitting in the gallery column exactly
  //      where it always has (compact clipped view + trigger button);
  //   2. a *modal* appended directly to document.body once, at setup time,
  //      completely outside every section-level stacking context.
  // The real .jdgm-widget itself is moved (not cloned — one instance, one
  // source of truth) between these two containers on open/close. Moving the
  // widget ROOT (not a piece of it) preserves 100% of its internal ancestry,
  // exactly like wrapping does.
  function setupGalleryModal(galleryWidget, root) {
    if (galleryWidget.dataset.aspModalReady === 'true') return;

    // The portal (modalRoot) lives in document.body, outside `root` entirely,
    // so replacing `root`'s HTML on a section reload does NOT remove it —
    // that's what orphaned a stale modal in document.body on every editor
    // reload before this check existed. The reference is kept on `root`
    // itself (never a document-wide selector), so this only ever sees and
    // touches the ONE portal that belongs to this exact section instance.
    var existing = root.__aspGalleryModal;
    if (existing && existing.galleryWidget === galleryWidget && existing.modalRoot.isConnected) {
      // Already fully set up for this exact widget node; nothing to do.
      galleryWidget.dataset.aspModalReady = 'true';
      return;
    }
    if (existing) {
      // A previous widget node for this same section instance left a portal
      // behind (e.g. Judge.me rebuilt its widget without a full section
      // reload) — tear it down before building the new one so this instance
      // never accumulates more than one portal in document.body.
      existing.destroy();
      root.__aspGalleryModal = null;
    }

    galleryWidget.dataset.aspModalReady = 'true';
    // Stable marker so the widget's own styling (border-radius, gap, image
    // filter, etc.) travels with it whether it currently sits in the local
    // teaser or the document.body-level modal — see the CSS comment above
    // .ambienta-social-proof__gallery-widget for why ancestry-based scoping
    // (".ambienta-social-proof .jdgm-...") breaks once the widget portals out.
    galleryWidget.classList.add('ambienta-social-proof__gallery-widget');

    var originalParent = galleryWidget.parentNode;

    // --- Teaser (stays local, in the gallery column) ---
    var teaser = document.createElement('div');
    teaser.className = 'ambienta-social-proof__gallery-teaser';
    originalParent.insertBefore(teaser, galleryWidget);

    var teaserBody = document.createElement('div');
    teaserBody.className = 'ambienta-social-proof__gallery-teaser-body';
    teaser.appendChild(teaserBody);
    teaserBody.appendChild(galleryWidget);

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ambienta-social-proof__gallery-trigger';
    trigger.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        '<rect x="3" y="3" width="18" height="18" rx="3"/>' +
        '<circle cx="8.5" cy="9" r="1.5"/>' +
        '<path d="M4 17l5-5 3 3 4-4 4 4"/>' +
      '</svg>' +
      '<span>Ver todas las fotos</span>';
    teaser.appendChild(trigger);

    // --- Modal (portaled to document.body, independent of any ancestor) ---
    var modalId = 'asp-gallery-modal-title-' + Math.random().toString(36).slice(2, 9);
    var modalRoot = document.createElement('div');
    modalRoot.className = 'ambienta-social-proof__gallery-modal';

    var backdrop = document.createElement('div');
    backdrop.className = 'ambienta-social-proof__gallery-modal-backdrop';
    modalRoot.appendChild(backdrop);

    var panel = document.createElement('div');
    panel.className = 'ambienta-social-proof__gallery-modal-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', modalId);
    panel.innerHTML =
      '<div class="ambienta-social-proof__gallery-modal-header">' +
        '<div>' +
          '<p class="ambienta-social-proof__gallery-modal-title" id="' + modalId + '">Fotos de nuestros clientes</p>' +
          '<p class="ambienta-social-proof__gallery-modal-subtitle">Descubre cómo nuestros clientes disfrutan los productos Ambienta en sus hogares.</p>' +
        '</div>' +
        '<button type="button" class="ambienta-social-proof__gallery-modal-close" aria-label="Cerrar galería">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
      '</div>';
    modalRoot.appendChild(panel);

    var modalBody = document.createElement('div');
    modalBody.className = 'ambienta-social-proof__gallery-modal-body';
    panel.appendChild(modalBody);

    document.body.appendChild(modalRoot);

    var closeBtn = panel.querySelector('.ambienta-social-proof__gallery-modal-close');
    var inertedSiblings = [];

    function getFocusable() {
      var nodes = panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      return Array.prototype.filter.call(nodes, function (el) {
        return el.offsetParent !== null;
      });
    }

    function trapFocus(event) {
      if (event.key !== 'Tab') return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function setBackgroundInert(on) {
      // Marks every other direct child of <body> inert while the modal is
      // open, so background links/buttons are unreachable by keyboard or
      // assistive tech too, not just visually covered. Judge.me's own native
      // photo lightbox (#jdgm-carousel-lightbox-root) is excluded: it is a
      // permanent document.body child that Judge.me opens ON TOP of this
      // modal when a customer clicks a photo inside the gallery, so it must
      // stay interactive — marking it inert silently blocked that lightbox
      // from being usable until this modal was closed.
      if (on) {
        inertedSiblings = [];
        Array.prototype.forEach.call(document.body.children, function (el) {
          if (el === modalRoot) return;
          if (el.id === 'jdgm-carousel-lightbox-root') return;
          if ('inert' in el) {
            el.inert = true;
            inertedSiblings.push(el);
          }
        });
      } else {
        inertedSiblings.forEach(function (el) {
          el.inert = false;
        });
        inertedSiblings = [];
      }
    }

    function openModal() {
      // Move the one real widget instance into the modal's body. Nothing is
      // cloned or duplicated — the teaser is simply left empty until close.
      modalBody.appendChild(galleryWidget);
      modalRoot.classList.add('is-open');
      document.documentElement.classList.add('ambienta-social-proof-modal-open');
      document.body.classList.add('ambienta-social-proof-modal-open');
      setBackgroundInert(true);
      document.addEventListener('keydown', onKeydown, true);
      window.setTimeout(function () {
        closeBtn.focus();
      }, 10);
    }

    // Focus deterministically returns to the trigger ("Ver todas las
    // fotos") on close, per spec — not a generic "whatever had focus
    // before" restore, which is unreliable when the modal is opened
    // programmatically instead of by a direct user click.
    function closeModal() {
      modalRoot.classList.remove('is-open');
      document.documentElement.classList.remove('ambienta-social-proof-modal-open');
      document.body.classList.remove('ambienta-social-proof-modal-open');
      setBackgroundInert(false);
      document.removeEventListener('keydown', onKeydown, true);
      // Move the widget back to its compact teaser position.
      teaserBody.appendChild(galleryWidget);
      trigger.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      trapFocus(event);
    }

    function onTriggerClick(event) {
      event.preventDefault();
      openModal();
    }

    function onCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeModal();
    }

    // Backdrop closes the modal; the panel stops the click from ever
    // reaching the backdrop, so interacting with the gallery itself can
    // never accidentally dismiss it.
    function onBackdropClick(event) {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    }

    function onPanelClick(event) {
      event.stopPropagation();
    }

    trigger.addEventListener('click', onTriggerClick);
    closeBtn.addEventListener('click', onCloseClick);
    backdrop.addEventListener('click', onBackdropClick);
    panel.addEventListener('click', onPanelClick);

    // Full teardown for this instance's portal only. If the section is
    // unloaded/replaced while the modal happens to be open, this closes it
    // first — restoring the html/body classes, un-inerting the background,
    // removing the document-level keydown listener, and returning focus
    // exactly as a normal close does — before removing every listener this
    // function added and detaching modalRoot from document.body.
    function destroy() {
      if (modalRoot.classList.contains('is-open')) {
        closeModal();
      }
      trigger.removeEventListener('click', onTriggerClick);
      closeBtn.removeEventListener('click', onCloseClick);
      backdrop.removeEventListener('click', onBackdropClick);
      panel.removeEventListener('click', onPanelClick);
      document.removeEventListener('keydown', onKeydown, true);
      if (modalRoot.isConnected) modalRoot.remove();
    }

    root.__aspGalleryModal = { galleryWidget: galleryWidget, modalRoot: modalRoot, destroy: destroy };
  }

  function warn(root, message) {
    if (root.querySelector('[data-asp-warning="' + message + '"]')) return;
    var el = document.createElement('p');
    el.className = 'ambienta-social-proof__block-warning';
    el.setAttribute('data-asp-warning', message);
    el.textContent = '⚠ ' + message;
    root.querySelector('.ambienta-social-proof__widgets').appendChild(el);
  }

  // .jdgm-stars only renders visually inside its original .jdgm-widget
  // ancestor, so once relocated it is drawn with CSS (see the stylesheet).
  // This reads the exact percentage from Judge.me's own rendered text
  // ("4.97 ★ (34)") — never a separate or hardcoded number — and exposes it
  // as a CSS custom property for that drawing to use.
  function applyStarFill(slot) {
    var ratingText = slot.querySelector('.jdgm-rating-text');
    var starsEl = slot.querySelector('.jdgm-stars');
    if (!ratingText || !starsEl) return;
    var match = ratingText.textContent.match(/(\d+(\.\d+)?)/);
    if (!match) return;
    var value = Math.max(0, Math.min(5, parseFloat(match[1])));
    starsEl.style.setProperty('--asp-star-pct', (value / 5 * 100) + '%');
  }

  // Moves the exact .jdgm-header-info node Judge.me already rendered (real
  // stars/average/count/verified badge) into this section's own rating slot,
  // instead of ever writing our own copy of that data.
  function moveRatingSummary(root) {
    var slot = root.querySelector('[data-asp-rating-slot]');
    if (!slot) return true; // Rating summary disabled for this instance.
    var ratingInfo = root.querySelector('.jdgm-header .jdgm-header-info');
    if (!ratingInfo) return false; // Not rendered yet.
    slot.appendChild(ratingInfo);
    slot.dataset.filled = 'true';
    applyStarFill(slot);
    return true;
  }

  // Judge.me can re-render a widget's contents after user interaction. This
  // keeps a second, lightweight watch so a freshly re-rendered
  // .jdgm-header-info also gets relocated, instead of leaving a stale/
  // duplicate one behind. Scoped to .jdgm-header itself (not the whole
  // section): that's the only place .jdgm-header-info can ever reappear, and
  // it excludes both widgets' own card/grid trees, which is where most of
  // the DOM churn (carousel re-renders, "mostrar más" appending photos,
  // gallery modal opening/closing) actually happens. Mutation bursts that
  // land in the same tick are coalesced into one processing pass via
  // queueMicrotask instead of re-querying the DOM once per burst.
  function watchForRerender(root) {
    if (root.dataset.aspRerenderWatch === 'true') return;
    root.dataset.aspRerenderWatch = 'true';
    var headerEl = root.querySelector('.jdgm-header') || root;
    var pending = false;
    var rerenderObserver = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
      if (!relevant || pending) return;
      pending = true;
      queueMicrotask(function () {
        pending = false;
        var freshInfo = headerEl.querySelector('.jdgm-header-info');
        if (freshInfo) moveRatingSummary(root);
      });
    });
    rerenderObserver.observe(headerEl, { childList: true, subtree: true });
    root.__aspRerenderObserver = rerenderObserver;
  }

  // Disconnects every observer and removes every portal/listener this
  // section instance created. Safe to call more than once (checks before
  // acting) and safe on a root that was never fully initialized. Only ever
  // touches state stored on this exact `root` — never a document-wide
  // selector — so it can never affect another instance's observers or modal.
  function teardown(root) {
    if (root.__aspBootstrapObserver) {
      root.__aspBootstrapObserver.disconnect();
      root.__aspBootstrapObserver = null;
    }
    if (root.__aspRerenderObserver) {
      root.__aspRerenderObserver.disconnect();
      root.__aspRerenderObserver = null;
    }
    if (root.__aspGalleryModal) {
      root.__aspGalleryModal.destroy();
      root.__aspGalleryModal = null;
    }
  }

  // shopify:section:load's event.target is the *wrapper* Shopify generates
  // around every section (stable across reloads — only its contents get
  // replaced). Keying cleanup off that wrapper, instead of off `root`
  // itself, is what makes teardown actually reachable on a reload: by the
  // time the event fires, the OLD `.ambienta-social-proof` node has already
  // been detached (its innerHTML was replaced before the event dispatches),
  // so a handler that only looks for "the current .ambienta-social-proof
  // inside event.target" can only ever find the NEW node — teardown(newRoot)
  // is a no-op, since the new node was never set up yet. This WeakMap
  // remembers, per wrapper, the teardown for whichever instance is currently
  // live inside it, so the reload handler can tear down the outgoing
  // instance before the incoming one is initialized.
  var instanceTeardownByWrapper = new WeakMap();

  function registerInstance(root) {
    var wrapper = root.closest('.shopify-section') || root;
    instanceTeardownByWrapper.set(wrapper, function () {
      teardown(root);
    });
  }

  function teardownWrapper(wrapper) {
    var fn = wrapper && instanceTeardownByWrapper.get(wrapper);
    if (fn) {
      fn();
      instanceTeardownByWrapper.delete(wrapper);
    }
  }

  function init(root) {
    if (!root || root.dataset.aspBound === 'true') return;
    teardown(root);
    root.dataset.aspBound = 'true';
    registerInstance(root);

    // Once both widget roles are found, the wrapper nodes that carry
    // data-widget-role are created by Liquid (not by Judge.me's Vue apps)
    // and never get torn down by a widget re-render — only their *contents*
    // churn. So re-running assignWidgetRoles (and its querySelectorAll) on
    // every later mutation burst is pure waste once both roles are locked
    // in; this only re-runs it if that's not yet true, or if a previously
    // -found wrapper somehow left the document.
    var rolesLocked = false;
    var lockedWidgets = null;

    function rolesStillValid() {
      return rolesLocked && lockedWidgets.every(function (w) { return w.isConnected; });
    }

    function ensureRoles() {
      if (rolesStillValid()) return;
      assignWidgetRoles(root);
      var widgets = root.querySelectorAll('.ambienta-social-proof__widget[data-widget-role]');
      var hasGallery = false;
      var hasReviews = false;
      widgets.forEach(function (w) {
        var role = w.getAttribute('data-widget-role');
        if (role === 'gallery') hasGallery = true;
        if (role === 'reviews') hasReviews = true;
      });
      if (hasGallery && hasReviews) {
        rolesLocked = true;
        lockedWidgets = Array.prototype.slice.call(widgets);
      }
    }

    ensureRoles();

    if (moveRatingSummary(root)) {
      watchForRerender(root);
      return;
    }

    // No fixed timeout: MutationObserver is push-based and costs nothing
    // while idle, so there is no upside to giving up after a fixed delay —
    // on a slow connection the summary still gets relocated whenever
    // Judge.me actually finishes rendering, however long that takes.
    // Mutations are filtered (only addedNodes matter here) and coalesced
    // via queueMicrotask before touching the DOM again, so a burst of
    // several synchronous mutations from Judge.me's initial mount runs this
    // processing once instead of once per mutation record.
    var pending = false;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length > 0; });
      if (!relevant || pending) return;
      pending = true;
      queueMicrotask(function () {
        pending = false;
        ensureRoles();
        if (moveRatingSummary(root)) {
          observer.disconnect();
          root.__aspBootstrapObserver = null;
          watchForRerender(root);
        }
      });
    });
    observer.observe(root, { childList: true, subtree: true });
    root.__aspBootstrapObserver = observer;
  }

  function initAll(context) {
    (context || document).querySelectorAll('.ambienta-social-proof').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-runs for this exact instance when the merchant edits it (or moves it)
  // in the theme editor, which replaces the section's HTML with a fresh copy.
  // The outgoing instance is torn down via the stable wrapper lookup above —
  // not via event.target.querySelector, which by this point can only ever
  // find the NEW (not-yet-initialized) node.
  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target;
    if (!wrapper || !wrapper.querySelector) return;
    teardownWrapper(wrapper);
    var root = wrapper.querySelector('.ambienta-social-proof');
    if (root) {
      root.dataset.aspBound = 'false';
      root.dataset.aspRerenderWatch = 'false';
      init(root);
    }
  });

  // Fires when a section is removed entirely (not just re-rendered) in the
  // theme editor. Without this, an instance deleted from the page would
  // leave its observers (and gallery modal portal) running/attached
  // indefinitely.
  document.addEventListener('shopify:section:unload', function (event) {
    teardownWrapper(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
